(function () {
  const tagMap = {
    blog: {
      title: "The ShortVideo AI Blog",
      description:
        "Actionable insights for creators, marketers, and brands. Learn how to scale your content with our AI Agent, master Veo 3 Ads, and create high-converting product videos.",
      imgUrl:
        "https://file.shortvideo.ai/assets/web/resources/blog-collection-header.png",
      imgAlt:
        "An illustration for the ShortVideo AI blog, showing icons for video creation, ad analytics, and e-learning content.",
      seoTitle:
        "AI Video Marketing Blog: Ad Creative & E-commerce Tips | ShortVideo AI",
      seoDesc:
        "Level up your video strategy with the ShortVideo AI blog. Get expert tips on creating AI video ads, product showcases, and viral content for TikTok and Reels.",
      ogTitle: "Master AI Video Creation: The Official Blog by ShortVideo AI",
      ogDesc:
        "From automating your content workflow with our AI Agent to creating stunning product videos in seconds—our blog is your guide to success.",
      ogType: "website",
      ogUrl: "https://shortvideo.ai/resources/blog/",
      twitterTitle:
        "The AI Video Blog for Marketers & Creators | ShortVideo AI",
      twitterDesc:
        "Stop guessing. Get proven strategies for AI video ads, product showcases, and viral marketing, straight from the ShortVideo AI team.",
      twitterCard: "summary_large_image",
      twitterSite: "",
    },
    reviews: {
      title: "AI Video Tool Reviews (2025)",
      description:
        "Honest, hands-on reviews of the best AI video generators. We break down usability, pricing, and specific features like AI Agent performance and template quality.",
      imgUrl:
        "https://file.shortvideo.ai/assets/web/resources/reviews-collection-header.png",
      imgAlt:
        "An image showing a checklist and a magnifying glass over AI video tool features, symbolizing a detailed review process.",
      seoTitle: "Best AI Video Tool Reviews (2025) | In-Depth & Unbiased",
      seoDesc:
        "Searching for honest AI video tool reviews? We provide hands-on analysis of top platforms to help marketers, creators, and brands find the perfect fit.",
      ogTitle:
        "Which AI Video Tool is *Actually* Worth It? Our In-Depth Reviews",
      ogDesc:
        "Don't get stuck with the wrong tool. Our unbiased reviews test everything from AI ad creation to product video workflows. Find the truth here.",
      ogType: "website",
      ogUrl: "https://shortvideo.ai/resources/reviews/",
      twitterTitle: "Unbiased AI Video Tool Reviews | By ShortVideo AI",
      twitterDesc:
        "We put the top AI video generators to the test. See our honest breakdown of features, pricing, and real-world performance.",
      twitterCard: "summary_large_image",
      twitterSite: "",
    },
    alternatives: {
      title: "Best AI Video Generator Alternatives",
      description:
        "Discover superior alternatives to common AI video tools. If you need a more intuitive workflow, better templates, and more affordable pricing, you're in the right place.",
      imgUrl:
        "https://file.shortvideo.ai/assets/web/resources/alternatives-collection-header.png",
      imgAlt:
        "A visual of a branching path with different AI video tool icons, representing the choice of finding a better alternative.",
      seoTitle:
        "Best AI Video Tool Alternatives (2025) | More Affordable & Powerful",
      seoDesc:
        "Looking for a better AI video creation experience? Our guides to the best alternatives help you find a more affordable and powerful solution for your business.",
      ogTitle:
        "Is Your AI Video Tool Overpriced? Explore These Powerful Alternatives",
      ogDesc:
        "Find a smarter way to create video ads and product content. We analyze the best alternatives, focusing on affordability, features, and ease of use for SMBs.",
      ogType: "website",
      ogUrl: "https://shortvideo.ai/resources/alternatives/",
      twitterTitle:
        "Time for a Change? The Best AI Video Tool Alternatives Are Here.",
      twitterDesc:
        "Don't settle. Discover better, more affordable alternatives for AI video creation. Our guides help you make the switch with confidence.",
      twitterCard: "summary_large_image",
      twitterSite: "",
    },
    comparison: {
      title: "AI Video Platform Comparisons",
      description:
        "A head-to-head showdown. We compare ShortVideo AI's AI Agent, templates, and pricing against other leading tools so you can make a data-driven choice.",
      imgUrl:
        "https://file.shortvideo.ai/assets/web/resources/comparison-collection-header.png",
      imgAlt:
        "An illustration of two shields with different AI tool logos clashing, representing a head-to-head comparison.",
      seoTitle: "AI Video Tool Comparisons (2025) | ShortVideo AI vs. Others",
      seoDesc:
        "Which AI video platform is best? See our detailed, side-by-side comparisons of ShortVideo AI versus other popular tools on the market.",
      ogTitle: "AI Video Tool Face-Off: See How We Compare to the Competition",
      ogDesc:
        "We put ShortVideo AI head-to-head with other top platforms. See the data-driven verdict on features, price, and who wins for marketers and creators.",
      ogType: "website",
      ogUrl: "https://shortvideo.ai/resources/comparison/",
      twitterTitle:
        "The Ultimate AI Video Tool Showdown | ShortVideo AI Comparisons",
      twitterDesc:
        "Wondering how ShortVideo AI compares? See our direct, feature-by-feature comparisons against the competition. The results might surprise you.",
      twitterCard: "summary_large_image",
      twitterSite: "",
    },
  };

  // 设置或更新 meta 标签
  function setMetaTag(property, content, isProperty = false) {
    if (!content) return;

    const selector = isProperty
      ? `meta[property="${property}"]`
      : `meta[name="${property}"]`;

    let metaTag = document.querySelector(selector);

    if (!metaTag) {
      metaTag = document.createElement("meta");
      if (isProperty) {
        metaTag.setAttribute("property", property);
      } else {
        metaTag.setAttribute("name", property);
      }
      document.head.appendChild(metaTag);
    }

    metaTag.setAttribute("content", content);
  }

  // 设置或更新 title
  function setTitle(title) {
    if (title) {
      document.title = title;
    }
  }

  // 设置或更新 link canonical
  function setCanonical(url) {
    if (!url) return;

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }

  // 获取标签信息并设置 SEO
  const tagh1Node = document.querySelector(".post-card-title");
  const tagDescriptionNode = document.querySelector(".post-card-description");

  if (tagh1Node) {
    const tagName = tagh1Node.getAttribute("data-tag-name")?.toLowerCase();
    const tagData = tagMap[tagName];

    if (tagName && tagData) {
      // 设置页面标题和描述
      tagh1Node.textContent = tagData.title || tagName;
      tagDescriptionNode.textContent = tagData.description || "";

      // 设置 SEO meta 标签
      setTitle(tagData.seoTitle || tagData.title);
      setMetaTag("description", tagData.seoDesc || tagData.description);

      // 设置 Open Graph meta 标签
      setMetaTag(
        "og:title",
        tagData.ogTitle || tagData.seoTitle || tagData.title,
        true
      );
      setMetaTag(
        "og:description",
        tagData.ogDesc || tagData.seoDesc || tagData.description,
        true
      );
      setMetaTag("og:type", tagData.ogType || "website", true);
      setMetaTag("og:url", tagData.ogUrl || window.location.href, true);
      if (tagData.imgUrl) {
        setMetaTag("og:image", tagData.imgUrl, true);
      }

      // 设置 Twitter Card meta 标签
      setMetaTag("twitter:card", tagData.twitterCard || "summary_large_image");
      setMetaTag(
        "twitter:title",
        tagData.twitterTitle ||
          tagData.ogTitle ||
          tagData.seoTitle ||
          tagData.title
      );
      setMetaTag(
        "twitter:description",
        tagData.twitterDesc ||
          tagData.ogDesc ||
          tagData.seoDesc ||
          tagData.description
      );
      if (tagData.imgUrl) {
        setMetaTag("twitter:image", tagData.imgUrl);
      }
      if (tagData.twitterSite) {
        setMetaTag("twitter:site", tagData.twitterSite);
      }

      // 设置 canonical URL
      if (tagData.ogUrl) {
        setCanonical(tagData.ogUrl);
      }
    }
  }
})();
